import React, { useState } from "react";
import Select from "react-select";
import {

    FormGroup,
    Label,

} from "reactstrap";
import { ADOBE_FONT_FAMILIES } from "./data";


function FontSelector({selectedFont,onChange,...props}) {


    return (
        <div>
            <Label for="fontFamily">Font Family</Label>
            <Select
                value={selectedFont}
                onChange={(e) => {
                    if (e) {
                        onChange(e.fontName)
                    } else {
                        onChange("")
                    }
                }}
                options={ADOBE_FONT_FAMILIES}
                getOptionLabel={(option) => option.name}
                getOptionValue={(option) => option.fontName}
                valueKey="fontName"
                labelKey="name"
                {
                    ...props
                }
            />

        </div>
    )
}


export default FontSelector;